import ChevronDownIcon from '@images/chevron-bottom.svg?react';

import { StyledCardHeaderExpand, StyledCardHeaderExpandButton } from './PlannerSchoolCardExpandButton.styles';

interface PlannerSchoolCardExpandButtonProps {
  isExtended: boolean;
  onExtendedToggle: () => void;
}

export const PlannerSchoolCardExpandButton = (props: PlannerSchoolCardExpandButtonProps) => {
  const { isExtended, onExtendedToggle } = props;

  return (
    <StyledCardHeaderExpand>
      <StyledCardHeaderExpandButton isExtended={isExtended} onClick={onExtendedToggle}>
        <ChevronDownIcon data-testid={isExtended ? 'chevronTop' : 'chevronDown'} />
      </StyledCardHeaderExpandButton>
    </StyledCardHeaderExpand>
  );
};
